import React,{ useState,useRef } from 'react';
import axios from 'axios';

const OemRequestInfo = () => {
	const[fName, setFName] = useState('');
	const[lName, setLName] = useState('');
	const[email, setEmail] = useState('');
	const[tel, setTel] = useState('');
	const[company, setCompany] = useState('');
	const[location, setLocation] = useState('');
	const[tellus, setTellus] = useState('')
	
	const fNameRef = useRef();
	const lNameRef = useRef();
	const emailRef = useRef();
	const telRef = useRef();
	const companyRef = useRef();
	const locRef = useRef();
	const tellRef = useRef();
	const sendData = (e) =>{
		e.preventDefault();
		var reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
		if(fName === ''){
			alert("You didn't enter first Name.")
			fNameRef.current.focus();
			return false;
		}
		else if(lName === ''){
			alert("You didn't enter a last Name");
			lNameRef.current.focus();
			return false;
		}
		else if (email === ''){
			alert("You didn't enter a Email");
			emailRef.current.focus();
			return false;
		}
		else if(!reg.test(email)){
			alert("Invalid Email ID");
			emailRef.current.select();
			return false;
		}
		else if (tel === "") {
			alert("You didn't enter a phone number.");
			telRef.current.focus();
			return false;
		}
		else if (isNaN(tel)) {
			alert("The phone number contains illegal characters.");
			telRef.current.select();
			return false;
		}
		else if ((tel.length > 10)) {
			alert("The phone number should 10 digits");
			telRef.current.select();
			return false;
		}
		else if ((tel.length < 10)) {
			alert("The phone number should 10 digits");
			telRef.current.select();
			return false;
		}
		else if (company === "") {
			alert("You didn't enter a company details.");
			companyRef.current.focus();
			return false;
		}
		else if (location === "") {
			alert("You didn't enter location.");
			locRef.current.focus();
			return false;
		}
		else if (tellus === "") {
			alert("You didn't enter your requirements.");
			tellRef.current.focus();
			return false;
		}
		else{
			axios.post('http://65.2.87.19:8085/notify/request',{
				firstName: fName,
				lastName: lName,
				mobile: tel,
				email: email,
				company: company,
				title: location,
				description : tellus,
				type:'DEALER'
			},
			{
				headers : {"Content-Type": "application/json"}
				
			}).then((response)=>{
				console.log(response)
			}).then((error)=>{
				console.log(error)
			})
		}
	}
	return (
    <section id="c-sectionRequestInfoForm" className="c-sectionWrapper">
		<div className="container">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold">Make Inquiries </h5>
				<div className="row justify-content-lg-center">
					<div className="col-lg-6 col-md-12">						
						<p className="c-para22Regular">Understand how you can boost your buyer lending firm by approving more borrowers within your credit policy with 100% automated decisioning.</p>
					</div>
				</div>
			</div>

			<div className="row justify-content-lg-center">
				<div className="col-lg-10 col-md-12">						
					<div className="c-customForm">
						<form onSubmit={sendData}>
							<div className="row">
								<div className="col-sm-6 col-xs-12">
									<div className="form-group">
										<input type="text" name="fName" ref={fNameRef} placeholder="First name" className="form-control" id="fName" onChange={(e)=>{setFName(e.target.value)}} />
									</div>
								</div>
								<div className="col-sm-6 col-xs-12">
									<div className="form-group">
										<input type="text" name="lName" ref={lNameRef} placeholder="Last name" className="form-control" id="lName" onChange={(e)=>{setLName(e.target.value)}}/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6 col-xs-12">
									<div className="form-group">
										<input type="email" name="email" ref={emailRef} placeholder="Email address" className="form-control" id="email" onChange={(e)=>{setEmail(e.target.value)}}/>
									</div>
								</div>
								<div className="col-sm-6 col-xs-12">
									<div className="form-group">
										<input type="text" name="tel" ref={telRef} placeholder="Phone number" className="form-control" id="tel" onChange={(e)=>{setTel(e.target.value)}}/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6 col-xs-12">
									<div className="form-group">
										<input type="text" ref={companyRef} name="company" placeholder="Company" className="form-control" id="company" onChange={(e)=>{setCompany(e.target.value)}} />
									</div>
								</div>
								<div className="col-sm-6 col-xs-12">
									<div className="form-group">
										<input type="text" name="location" ref={locRef} placeholder="Location" className="form-control" id="title" onChange={(e)=>{setLocation(e.target.value)}} />
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12 col-xs-12">
									<div className="form-group">
										<textarea name="tellUs" ref={tellRef} placeholder="Tell us about your requirements" className="form-control" id="textarea" onChange={(e)=>{setTellus(e.target.value)}}></textarea>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12 col-xs-12 text-left">
									<button type="submit" name="" className="c-btnOrangeSolidSharp">Get in Touch &nbsp;&nbsp; <b>></b></button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>			
		</div>
	</section>
  )
}

export default OemRequestInfo